import * as React from "react";
import { AppBar, Box, Toolbar, Typography, Button, Container, IconButton, Drawer, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

const Header = ({ scrollHome, scrollAbout, scrollServices, scrollContact }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:900px)");

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleNavigation = (targetScroll, path) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(targetScroll, 300); // Delay for smooth transition
    } else {
      targetScroll();
    }
    setMobileOpen(false); // Close mobile menu after clicking
  };

  const toggleDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  const menuItems = [
    { label: "Home", action: () => handleNavigation(scrollHome, "/") },
    { label: "About Us", action: () => handleNavigation(scrollAbout, "/aboutus") },
    { label: "Services", action: () => handleNavigation(scrollServices, "/services") },
    { label: "Contact", action: () => handleNavigation(scrollContact, "/contact") },
  ];

  return (
    <AppBar position="fixed" sx={{ bgcolor: "#16215a", top: 0, zIndex: 1100 }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box component="img" src="/logo.svg" alt="Logo" sx={{ height: 40, mr: 2 }} />

          <Typography
            variant="h6"
            noWrap
            component={Link}
            to="/"
            sx={{
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
          </Typography>

          <Box sx={{ flexGrow: 1 }} />

          {!isMobile && (
            <Box sx={{ display: "flex", gap: 2 }}>
              {menuItems.map((item) => (
                <Button key={item.label} onClick={item.action} sx={{ color: "white" }}>
                  {item.label}
                </Button>
              ))}
            </Box>
          )}

          {!isMobile && (
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                variant="outlined"
                onClick={() => window.open("https://dashboard-dev.qyser.xyz", "_blank")}
                sx={{ color: "white", borderColor: "#111d57", width: "146px", height: "52px" }}
              >
                Login
              </Button>
              <Button
                variant="contained"
                component={Link}
                to="/signup"
                sx={{ bgcolor: "white", color: "black", width: "146px", height: "52px" }}
              >
                Signup
              </Button>
            </Box>
          )}

          {isMobile && (
            <>
              <IconButton edge="end" color="inherit" aria-label="menu" onClick={toggleDrawer}>
                <MenuIcon />
              </IconButton>

              <Drawer anchor="right" open={mobileOpen}
               onClose={toggleDrawer}>
                <List sx={{ width: 250,backgroundColor:"#16215a", height: "100vh", border: "none" }}>
                  {menuItems.map((item) => (
                    <ListItem key={item.label} disablePadding>
                      <ListItemButton onClick={() => item.action()}>
                        <ListItemText primary={item.label}  sx={{ color: "#fff" }}/>
                      </ListItemButton>
                    </ListItem>
                  ))}

                  <ListItem>
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={() => window.open("https://dashboard-dev.qyser.xyz", "_blank")}
                      sx={{ color: "white", borderColor: "#111d57", mt: 2 }}
                    >
                      Login
                    </Button>
                  </ListItem>
                  <ListItem>
                    <Button
                      fullWidth
                      variant="contained"
                      component={Link}
                      to="/signup"
                      sx={{ bgcolor: "#111d57", color: "white" }}
                    >
                      Signup
                    </Button>
                  </ListItem>
                </List>
              </Drawer>
            </>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
